/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Filter_UncategorizedInputs */

const vi_expense_filter_uncategorized = /** @type {(inputs: Expense_Filter_UncategorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa phân loại`)
};

/**

* @param {Expense_Filter_UncategorizedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_filter_uncategorized = /** @type {((inputs?: Expense_Filter_UncategorizedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Filter_UncategorizedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_filter_uncategorized(inputs)
});